import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faBan } from '@fortawesome/free-solid-svg-icons';

const EndpointNumber = (props) => {
  const { endpointNumber } = props;

  const [endpoint, setEndpoint] = useState(endpointNumber) ;
  
  return (
      <td>{ endpoint }</td>
  )
}

export default EndpointNumber;